import { render, staticRenderFns } from "./QueryCompHisto.vue?vue&type=template&id=7c12be90&"
import script from "./QueryCompHisto.vue?vue&type=script&lang=js&"
export * from "./QueryCompHisto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports